export const sum = (...numbers: number[]): number => {
  return numbers.reduce((acc, cur) => acc + cur, 0);
};
